import getReducer from '../getReducer';
import assign from 'object-assign';

import {LOGIN_LOGIN_REQUEST, LOGIN_LOGIN_SUCCESS, LOGIN_LOGIN_FAILURE} from '../../action/login/login'
import {CAPTCHA_CREATE_REQUEST, CAPTCHA_CREATE_SUCCESS, CAPTCHA_CREATE_FAILURE} from '../../action/login/captchaCreate'
import {CAPTCHA_VALIDATE_REQUEST, CAPTCHA_VALIDATE_SUCCESS, CAPTCHA_VALIDATE_FAILURE} from '../../action/login/captchaValidate'

function login(state = {
	isLoginIng: false,
}, action) {
	switch (action.type) {
		case LOGIN_LOGIN_REQUEST:
			return assign({}, state, {isLoginIng: true})
		case LOGIN_LOGIN_SUCCESS:
			return assign({}, state, {isLoginIng: false})
		case LOGIN_LOGIN_FAILURE:
			return assign({}, state, {isLoginIng: false})
		// 获取验证码
		case CAPTCHA_CREATE_REQUEST:
			return assign({}, state, {})
		case CAPTCHA_CREATE_SUCCESS:
			return assign({}, state, {})
		case CAPTCHA_CREATE_FAILURE:
			return assign({}, state, {})
		
		// 校验验证码
		case CAPTCHA_VALIDATE_REQUEST:
			return assign({}, state, {})
		case CAPTCHA_VALIDATE_SUCCESS:
			return assign({}, state, {})
		case CAPTCHA_VALIDATE_FAILURE:
			return assign({}, state, {})
			
		default:
			return state;
	}
}

export default getReducer(login);


// WEBPACK FOOTER //
// ./src/reducer/authorization/index.js